import { Injectable, NgZone } from '@angular/core';
import {
  MatLegacySnackBar as MatSnackBar,
  MatLegacySnackBarConfig as MatSnackBarConfig,
} from '@angular/material/legacy-snack-bar';

import { SaveCancelService } from './state/save-cancel.service';
import { MessageSnackbarComponent } from '@shared/components/message-snackbar/message-snackbar.component';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(
    private snackBar: MatSnackBar,
    private zone: NgZone,
    private saveCancelService: SaveCancelService,
  ) {}

  private successMessages: string[][] = [];
  private isVisible = false;

  public showSuccess(message: string[], duration: number = 3000): void {
    this.successMessages.push(message);
    if (!this.isVisible) this.showSuccessMessage(duration);
  }

  public showError(message: string[], duration: number = 5000): void {
    const configError: MatSnackBarConfig<MessageSnackbarComponent> = {
      panelClass: 'error',
      verticalPosition: 'top',
      duration,
    };
    this.openSnackbar(message, configError);
  }

  private openSnackbar(
    message: string[],
    config: MatSnackBarConfig<MessageSnackbarComponent>,
  ) {
    // Wrap snackbar call in zone invocation to fix rendering inconsistencies
    this.zone.run(() => {
      this.saveCancelService.setDisabledState(false);
      this.isVisible = true;
      this.snackBar
        .openFromComponent(MessageSnackbarComponent, {
          data: message,
          ...config,
        })
        ?.afterDismissed()
        .subscribe(() => {
          this.isVisible = false;
          this.showSuccessMessage(config.duration);
        });
    });
  }

  private showSuccessMessage(duration: number) {
    const message = this.successMessages.shift();
    if (!message) return;
    const configSuccess: MatSnackBarConfig<MessageSnackbarComponent> = {
      panelClass: 'success',
      verticalPosition: 'bottom',
      duration,
    };
    this.openSnackbar(message, configSuccess);
  }
}
